module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-UltraLight.7621ea28.woff2";